import script from "./PictTextBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PictTextBlock.vue?vue&type=script&setup=true&lang=js"

import "./PictTextBlock.vue?vue&type=style&index=0&id=d5eb9db2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5eb9db2"]])

export default __exports__